import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormGroup, Field, Checkbox, CheckboxGroup, Radio, RadioGroup } from '@availity/form';
import '@availity/yup';
import { Row, Col, Button, Label } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class RiskFactors extends Component {

    constructor(props) {
      super(props);

      this.state = {
        redirectBack: false,
        redirectToHousingAssessment: false,
        redirectToHealthNeeds: false,
        redirectToLandingPage: false,
      }

      if(window.performance) {
        if(performance.navigation.type == 1) {
          housingstore.resetSupportiveHousingPage();
          window.location.href = '#';
        }
      }
    }

    componentWillMount() {
      if (housingstore.getSupportiveHousingRouteStatus('/healthneeds') !== 'completed') {
        housingstore.resetSupportiveHousingPage();
        housingstore.resetSupportiveHousingRoutesStatus();
        this.setState({ redirectToLandingPage: true });
      } else if (
        housingstore.getSupportiveHousingRouteStatus('/riskfactors') !== 'completed' &&
        housingstore.getSupportiveHousingRouteStatus('/riskfactors') !== 'active'
      ) {
        housingstore.setSupportiveHousingPageStatus('#healthneeds', 'active');
        housingstore.setSupportiveHousingRouteStatus('/riskfactors', 'active');
      }
    }
    
    componentDidMount() {
      window.onpopstate = () => {
        this.props.navigate(1); 
      }
    }

    getRiskFactors = event => {
        const { value } = event.target;
        if (event.target.checked) {
            housingstore.setRiskFactors(event.target.name, value);
        } else {
            housingstore.setRiskFactors(event.target.name, '');
        }
    }

    setRiskFactorsCategories = value => {
      housingstore.setRiskFactorCategories(value);
    }

    setInstSettingsCategories = value => {
      housingstore.setInstSettingsCategories(value);
    }

    setResCareFacilityCategories = value => {
      housingstore.setResCareFacilityCategories(value);
    }

    setInstitutionalSettings = value => {
      housingstore.setInstitutionalSettings(value);
    }

    setMultiInstSettings = value => {
      housingstore.setMultiInstSettings(value);
    }

    setCountDetails= event => {
      const { value } = event.target;
      housingstore.setCountDetails(value);
    }

    setMultiResidentialCare = value => {
      housingstore.setMultiResidentialCare(value);
    }

    setMultiInHomeCare = value => {
      housingstore.setMultiInHomeCare(value);
    }

    setAdditionalDetails = event => {
      const {value} = event.target;
      housingstore.updateAdditionalDetails(value);
    }

    goBack = () => {
      housingstore.setSupportiveHousingPageStatus('#healthneeds', 'active');
      housingstore.setSupportiveHousingRouteStatus('/healthneeds', 'active');
      housingstore.setSupportiveHousingRouteStatus('/riskfactors', 'inactive');
      this.setState({redirectToHealthNeeds: true});
    }

    submit = (pendingRoute = '/housingassessment') => {
      housingstore.setSupportiveHousingPageStatus('#healthneeds', 'active');
      housingstore.setSupportiveHousingRouteStatus('/riskfactors', 'completed');
      if (pendingRoute === '/housingassessment') {
        this.setState({redirectToHousingAssessment: true});
        return;
      }
      this.props.navigate(pendingRoute);
    }

  render() {

    
    const { 
      redirectToHealthNeeds,
      redirectToHousingAssessment,
      redirectBack,
      redirectToLandingPage
    } = this.state;
    
    const { 
      riskFactorsCategories,
      institutionalSettingsRadio,
      multiInstSettingsRadio,
      multiResidentialCareRadio,
      instSettingsCategories,
      resCareFacilityCategories,
      multiInHomeCareRadio,
      additionalDetails,
      countDetails,
      supportiveHousingPagesAHAH, 
      supportiveHousingPagesNoAHAH, 
      memberInfo
    } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if(redirectToHousingAssessment) {
      return <Navigate to="/housingassessment" />
    }
    
    if(redirectToHealthNeeds) {
      return <Navigate to="/healthneeds" />
    }

    if(redirectToLandingPage) {
      return <Navigate to="/" />
    }

    return(
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              riskFactors: riskFactorsCategories.map(x => x),
              institutionalSettingsRadio: institutionalSettingsRadio,
              instSettings: instSettingsCategories.map(x => x),
              multiInstSettingsRadio: multiInstSettingsRadio,
              countField: countDetails,
              multiResidentialCareRadio: multiResidentialCareRadio,
              resCareFacility: resCareFacilityCategories.map(x => x),
              multiInHomeCareRadio: multiInHomeCareRadio,
              additionalDetails: additionalDetails,
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              riskFactors: yup.array().isRequired(true, 'Please select an option before continuing!'),
              institutionalSettingsRadio: yup.string().isRequired(riskFactorsCategories.indexOf('Institutional Contacts') >= 0, 'Please select Yes / No!'),
              instSettings: yup.array().isRequired((institutionalSettingsRadio !== '' && institutionalSettingsRadio === 'Yes'), 'Please select at least one of the above options!'),
              multiInstSettingsRadio: yup.string().isRequired(riskFactorsCategories.indexOf('Institutional Contacts') >= 0, 'Please select Yes / No!'),
              countField: yup.string()
                .matches(/^\d{1,3}$/, 'Numbers Only')
                .isRequired(multiInstSettingsRadio === 'Yes', 'Please enter a value.'),
              multiResidentialCareRadio: yup.string().isRequired(riskFactorsCategories.indexOf('Residential Care') >= 0, 'Please select Yes / No!'),
              resCareFacility: yup.array().isRequired((multiResidentialCareRadio !== '' && multiResidentialCareRadio === 'Yes'), 'Please select at least one of the above options!'),
              multiInHomeCareRadio: yup.string().isRequired(riskFactorsCategories.indexOf('In Home Care') >= 0, 'Please select Yes / No!')
            })}
          >
            <small className="required-fields">*required fields </small>
            <div className="spacer-48" />
            <h2 className="poppinsH2 mb-5">
                Complex needs eligibility requirements
            </h2>
            <div className="spacer-24" />
            <h6 className="label-font">
              <i>Information in this section is required to determine eligibility for supportive housing services.</i>
            </h6>
            <div className='spacer-48' />
            <div className="d-flex">
              <h5 className="poppinsH5">
                Risk Factors*
              </h5>
              <p className="selectText">
                (must select at least one)
              </p>
            </div>
            <div className="spacer" />
            <Row>
              <Col className="checkbox-fix" lg='11'>
                <CheckboxGroup name="riskFactors" onChange={this.setRiskFactorsCategories}>
                  <Checkbox
                    label="Chronically homeless: an individual with a disabling condition who has been homeless for a 
                           period of at least one year, or an individual with a disabling condition who has had at least 
                           four episodes of homelessness, as long as the combined occasions equal at least 12 months."
                    name="chronicallyHomeless"
                    className="label-font mb-24 no-display no-display"
                    groupName="riskFactors"
                    value="Chronically Homeless"
                  />
                </CheckboxGroup>
              </Col>
            </Row>

              <div className="spacer" />

              <div className="label-font mb-32 pl-23">
                <span className="note-font">Note:&nbsp;</span>
                  {`This definition also includes individuals who previously met the U.S. Department of 
                  Housing and Urban Development (HUD) definition of chronic homelessness but have been housed 
                  in the last 60 days (Time housed may not exceed 60 days).`}
              </div>

              <div className="spacer" />

              <Row>
                <Col className="checkbox-fix" lg='12'>
                <CheckboxGroup name="riskFactors" onChange={this.setRiskFactorsCategories}>
                  <Checkbox 
                    label="Frequent or lengthy institutional contacts (frequent, as in two or more instances in the 
                      past 12 months, or lengthy, as in lasting 90 days or more)"
                    name="institutionalContacts"
                    className="label-font mb-24 no-display"
                    groupName="riskFactors"
                    value="Institutional Contacts"
                  />
                  </CheckboxGroup>
                </Col>
              </Row>

              <div className="mt-3" />

              <div className="subCategory"> 
              <Row>
                <Col>
                  <Label className="label-font mb-24">
                    Is the client transitioning out of an institutional setting?
                  </Label>
                  <RadioGroup inline value={institutionalSettingsRadio} name="institutionalSettingsRadio" onChange={this.setInstitutionalSettings}>
                    <Radio className="label-font-round" name="institutionalSettingsRadio" label="Yes" value="Yes" disabled={riskFactorsCategories.indexOf('Institutional Contacts') < 0}/>
                    <Radio className="label-font-round" name="institutionalSettingsRadio" label="No" value="No" disabled={riskFactorsCategories.indexOf('Institutional Contacts') < 0} />
                  </RadioGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                <Label className="label-font mb-16">
                  If yes, select all that apply: 
                </Label>
                <CheckboxGroup name="instSettings" value={instSettingsCategories} onChange={this.setInstSettingsCategories}>
                <Row>
                  <Col sm="4">
                    <Checkbox 
                      label="Nursing"
                      name="nursing"
                      className="label-font mb-24 no-display"
                      groupName="instSettings"
                      value="Nursing"
                      disabled={institutionalSettingsRadio === 'No' || institutionalSettingsRadio === ''}
                    />
                    <Checkbox 
                      label="Inpatient psychiatric hospital"
                      name="inpatientPsychiatricHospital"
                      className="label-font mb-24 no-display"
                      value="Inpatient psychiatric hospital"
                      disabled={institutionalSettingsRadio === 'No' || institutionalSettingsRadio === ''}
                    />
                    <Checkbox 
                      label="Inpatient medical hospital"
                      name="inpatientMedicalHospital"
                      className="label-font mb-32 no-display"
                      groupName="instSettings"
                      value="Inpatient medical hospital"
                      disabled={institutionalSettingsRadio === 'No' || institutionalSettingsRadio === ''}
                    />
                  </Col>
                  <Col sm = "6">
                    <Checkbox 
                      label="Correctional program or institution"
                      name="correctionalProgramOrInstitution"
                      className="label-font mb-24 no-display"
                      groupName="instSettings"
                      value="Correctional program or institution"
                      disabled={institutionalSettingsRadio === 'No' || institutionalSettingsRadio === ''}
                    />
                    <Checkbox 
                      label="Foster care facility or other youth facility"
                      name="fosterCareFacilityOrOtherYouthFacility"
                      className="label-font mb-24 no-display"
                      groupName="instSettings"
                      value="Foster care facility or other youth facility"
                      disabled={institutionalSettingsRadio === 'No' || institutionalSettingsRadio === ''}
                    />
                    </Col>
                  </Row>
                </CheckboxGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label className="label-font mb-24">
                    Has the client resided within one of the previously listed institutional settings multiple times in the past year?
                  </Label>
                  <RadioGroup inline value={multiInstSettingsRadio} name="multiInstSettingsRadio" onChange={this.setMultiInstSettings}>
                    <Radio className="label-font-round" label="Yes" value="Yes" disabled={riskFactorsCategories.indexOf('Institutional Contacts') < 0} />
                    <Radio className="label-font-round" label="No" value="No" disabled={riskFactorsCategories.indexOf('Institutional Contacts') < 0} />
                  </RadioGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="3">
                <Label className="label-font mb-32">
                  If yes, number of times:
                </Label>
                </Col>
                <Col xs="2">
                  <FormGroup for="countField">
                    <Field
                      type="text"
                      id="countField"
                      name="countField"
                      className="straighten-borders"
                      value={countDetails}
                      onChange={this.setCountDetails}
                      minLength={1}
                      maxLength={3}
                      disabled={multiInstSettingsRadio === '' || multiInstSettingsRadio === 'No'}
                      aria-label='Count Field'
                    />
                  </FormGroup>
                </Col>
              </Row>
              </div>
              <Row>
                <Col className="checkbox-fix">
                <CheckboxGroup name="riskFactors" onChange={this.setRiskFactorsCategories}>
                  <Checkbox 
                    label="Frequent residential care stays (two or more occurrences in the past 12 months)"
                    name="residentialCare"
                    className="label-font mb-24 no-display"
                    groupName="riskFactors"
                    value="Residential Care"
                  />
                  </CheckboxGroup>
                </Col>
              </Row>
              <div className="subCategory">
              <Row>
                <Col>
                  <Label className="label-font mb-24">
                    Has the client resided within a residential care facility two or more times in the past 12 months?
                  </Label>
                  <RadioGroup inline value={multiResidentialCareRadio} name="multiResidentialCareRadio" onChange={this.setMultiResidentialCare}> 
                    <Radio className="label-font-round" label="Yes" value="Yes" disabled={riskFactorsCategories.indexOf('Residential Care') < 0} />
                    <Radio className="label-font-round" label="No" value="No" disabled={riskFactorsCategories.indexOf('Residential Care') < 0} />
                  </RadioGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                <Label className="label-font mb-16">
                  If yes, select all that apply: 
                </Label>
                <CheckboxGroup name="resCareFacility" value={resCareFacilityCategories} onChange={this.setResCareFacilityCategories}>
                  <Row>
                    <Col sm="4">
                      <Checkbox 
                        label="Evaluation and treatment facility"
                        name="evaluationTreatmentFacility"
                        className="label-font mb-24 no-display"
                        groupName="resCareFacility"
                        value="Evaluation and treatment facility"
                        disabled={multiResidentialCareRadio === '' || multiResidentialCareRadio === 'No' }
                      />
                      <Checkbox 
                        label="Detox center"
                        name="detoxCenter"
                        className="label-font mb-32 no-display"
                        groupName="resCareFacility"
                        value="Detox center"
                        disabled={multiResidentialCareRadio === '' || multiResidentialCareRadio === 'No' }
                      />
                    </Col>
                    <Col sm = "8">
                      <Checkbox 
                        label="Inpatient substance use treatment facility"
                        name="inpatientSubstanceUseTreatmentFacility"
                        className="label-font mb-24 no-display"
                        groupName="resCareFacility"
                        value="Inpatient substance use treatment facility"
                        disabled={multiResidentialCareRadio === '' || multiResidentialCareRadio === 'No' }
                      />
                      <Checkbox
                        label="Adult residential care, assisted living or adult family home (AFH)"
                        name="adultResidentialCareOrAFH"
                        className="label-font mb-32 no-display"
                        groupName="resCareFacility"
                        value="Adult residential care, assisted living or adult family home (AFH)"
                        disabled={multiResidentialCareRadio === '' || multiResidentialCareRadio === 'No' }
                      />
                      </Col>
                    </Row>
                  </CheckboxGroup>
                </Col>
              </Row>
              </div>
              <Row>
                <Col className="checkbox-fix">
                <CheckboxGroup name= "riskFactors" onChange={this.setRiskFactorsCategories}>
                  <Checkbox 
                    label="Frequent turnover of in-home caregivers (three or more occurrences in the past 12 months)"
                    name="inHomeCare"
                    className="label-font mb-24 no-display"
                    groupName="riskFactors"
                    value="In Home Care"
                  />
                  </CheckboxGroup>
                </Col>
              </Row>
              <div className="subCategory">
              <Row>
                <Col>
                  <Label className="label-font mb-16">
                    Within the last 12 months, has the client used three (or more) different in-home caregiver providers (Please provide supporting documentation with the assessment)?
                  </Label>
                  <RadioGroup inline value={multiInHomeCareRadio} name="multiInHomeCareRadio" onChange={this.setMultiInHomeCare}>
                    <Radio className="label-font-round" label="Yes" value="Yes" disabled={riskFactorsCategories.indexOf('In Home Care') < 0} />
                    <Radio className="label-font-round" label="No" value="No" disabled={riskFactorsCategories.indexOf('In Home Care') < 0} />
                  </RadioGroup>
                </Col>
              </Row>
              </div>
              <Row>
                <Col>
                <CheckboxGroup name="riskFactors" onChange={this.setRiskFactorsCategories}>
                  <Checkbox 
                    label={`PRISM predictive risk score of 1.5 or above (contact the TPA, 
                            MCO, BHO, Health Home or HCS case manager to obtain the PRISM risk score).`}
                            name="prismScore"
                    className="label-font mb-32 no-display"
                    groupName="riskFactors"
                    value="Prism Score"
                  />
                  </CheckboxGroup>
                </Col>
              </Row>
              <Row>
                <Col sm = "6">
                  <FormGroup for="additionalDetails">
                    <Field
                      type="textarea"
                      id="additionalDetails"
                      label={
                        <h6 className="label-font">
                          Additional details on risk factors:
                        </h6>
                      }
                      name="additionalDetails"
                      className={'textAreaHeightDetails straighten-borders form-control form-group'}
                      onChange={this.setAdditionalDetails}
                      value={additionalDetails}
                      row="3"
                      cols="200"
                      maxLength={500}
                    />
                    <p className="small text-right mb-0 label-font">500 Character max</p>
                  </FormGroup>
                </Col>
              </Row>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

RiskFactors.propTypes = {
  navigate: PropTypes.func
};

export default withNavigate(RiskFactors);